/*
 * Defines all the groups used in the mmo client realm engine
 */
export enum MMORealmEngineGroups {
  BlueprintGroup = "blueprintGroup",
}
